import React from 'react';
import shapeImg from '../../assets/img/newsletter/shape-1-1.png';

const Newsletter = () => {
  return (
    <div className="it-newsletter-area it-newsletter-style-2 p-relative z-index tertiary-bg pt-100 pb-105">
      <div className="it-newsletter-shape-1 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-8">
            <div className="it-newsletter-wrap text-center">
              <h4 className="it-section-title text-white pb-40">
                Get Connected With Affirm And Enjoy Your New Experience
              </h4>
              <div className="it-newsletter-input-wrap d-flex align-items-center">
                <input type="email" placeholder="Your email address" />
                <button className="it-newsletter-button">
                  <span>Subscribe</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
